"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _EventCronParser_cron, _EventCronParser_prevDate, _EventCronParser_isRateExpression;
Object.defineProperty(exports, "__esModule", { value: true });
const parse_1 = require("./lib/parse");
const next_1 = require("./lib/next");
const desc_1 = require("./lib/desc");
const local_1 = require("./lib/local");
const constants_1 = require("./lib/constants");
__exportStar(require("./lib/local"), exports);
__exportStar(require("./lib/constants"), exports);
/**
 * cron is assumed to be validated by AWS already
 * cron is always stored in UTC
 * AWS Cron Expression specs
 * https://docs.aws.amazon.com/AmazonCloudWatch/latest/events/ScheduledEvents.html#CronExpressions
 */
/**
 * Every 5 minutes: rate(5 minutes, 3600000)
 * Every hour: rate(1 hour)
 * Every seven days: rate(7 days)
 */
class EventCronParser {
    // cron can be rate as well, maybe call it schedule instead?
    constructor(cron, start, end, tz) {
        _EventCronParser_cron.set(this, void 0); // can be either a cron or a rate expression
        _EventCronParser_prevDate.set(this, void 0);
        _EventCronParser_isRateExpression.set(this, void 0);
        if (cron.startsWith('rate(') && cron.at(-1) === ')') {
            __classPrivateFieldSet(this, _EventCronParser_isRateExpression, true, "f");
        }
        else {
            __classPrivateFieldSet(this, _EventCronParser_isRateExpression, false, "f");
        }
        this.tz = tz || 'local';
        __classPrivateFieldSet(this, _EventCronParser_cron, cron, "f");
        __classPrivateFieldSet(this, _EventCronParser_prevDate, new Date(0), "f"); // first occurrence will still be after start, cuz start put in parse
        this.latestDate = end ? new Date(end) : null;
        this.earliestDate = start ? new Date(start) : new Date(0);
        this.parsedCron = (0, parse_1.parse)(__classPrivateFieldGet(this, _EventCronParser_cron, "f"), start, end, __classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f"));
    }
    // if from is given, return next after or equal to from date
    // if from not given, give next after prev, prev is initialized as new Date(0)
    next(from, inclusive = false) {
        if (__classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f")) {
            let nextDate = (0, next_1.nextRate)(this.parsedCron, from || __classPrivateFieldGet(this, _EventCronParser_prevDate, "f"), inclusive);
            __classPrivateFieldSet(this, _EventCronParser_prevDate, nextDate, "f");
            return nextDate;
        }
        const cron = this.parsedCron;
        if (from !== undefined)
            __classPrivateFieldSet(this, _EventCronParser_prevDate, (0, next_1.nextCron)(cron, new Date(from), cron.duration, { inclusive, tz: this.tz }), "f");
        // including from
        else if (__classPrivateFieldGet(this, _EventCronParser_prevDate, "f"))
            __classPrivateFieldSet(this, _EventCronParser_prevDate, (0, next_1.nextCron)(cron, new Date(__classPrivateFieldGet(this, _EventCronParser_prevDate, "f").getTime() + cron.duration), cron.duration, {
                inclusive,
                tz: this.tz,
            }), "f"); // !!! not sure if i should be adding duration but seems right in next()?
        return __classPrivateFieldGet(this, _EventCronParser_prevDate, "f");
    }
    // export interface ParsedRate {
    //     rate: number, // in seconds
    //     duration: number, // in seconds
    //     value: number,
    //     unit: string,
    //     start: Date,
    //     end: Date | null,
    // }
    // !!! untested
    setRate(value = this.parsedCron.value, unit = this.parsedCron.unit, duration = undefined, start = this.earliestDate, end = this.latestDate) {
        __classPrivateFieldSet(this, _EventCronParser_isRateExpression, true, "f");
        let newDuration = duration !== undefined ? duration : this.parsedCron.duration || 0;
        const newCron = `rate(${value || 1} ${unit || 'days'}, ${newDuration})`;
        __classPrivateFieldSet(this, _EventCronParser_cron, newCron, "f");
        this.latestDate = end;
        this.earliestDate = start;
        this.parsedCron = (0, parse_1.parse)(newCron, start, end || undefined, true);
    }
    // !!! untested
    setCron(cron, start = this.earliestDate, end = this.latestDate) {
        if (cron.startsWith('rate(') && cron.at(-1) === ')') {
            __classPrivateFieldSet(this, _EventCronParser_isRateExpression, true, "f");
        }
        else {
            __classPrivateFieldSet(this, _EventCronParser_isRateExpression, false, "f");
        }
        this.latestDate = end;
        this.earliestDate = start;
        __classPrivateFieldSet(this, _EventCronParser_cron, cron, "f");
        this.parsedCron = (0, parse_1.parse)(__classPrivateFieldGet(this, _EventCronParser_cron, "f"), start, end || undefined, __classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f"));
    }
    // TODO !!!
    prev() {
        return;
    }
    // returns all occurences that occur within given interval
    // includes occurances that start
    range(start, end, inclusive) {
        const first = this.next(new Date(start), inclusive);
        const occurences = [];
        if (first === null)
            return occurences;
        occurences.push(first);
        while (true) {
            // add end to while statement, using at(-1)
            const occurence = this.next(undefined, inclusive);
            if (occurence === null || occurences[occurences.length - 1].getTime() >= new Date(end).getTime())
                return occurences;
            occurences.push(occurence);
        }
    }
    // check if an event occurs within the range start-end i think exclusive but not sure
    isInRange(start, end) {
        const first = this.next(new Date(start));
        return first && first.getTime() < new Date(end).getTime();
    }
    desc(timezone) {
        return (0, desc_1.getScheduleDescription)(this.parsedCron, __classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f"), timezone !== null && timezone !== void 0 ? timezone : this.tz);
    }
    // returns days of week in local time
    getLocalDays() {
        // should only be called if cron not rate expression
        if (__classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f"))
            return [];
        return (0, local_1.getLocalDays)(this.parsedCron);
    }
    getUTCMinutes() {
        if (__classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f")) {
            return this.earliestDate.getUTCMinutes();
        }
        return this.parsedCron.minutes[0];
    }
    getUTCHours() {
        if (__classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f")) {
            return this.earliestDate.getUTCHours();
        }
        return this.parsedCron.hours[0];
    }
    // hours and minutes are in UTC, preserveLocalDaysOfWeek keeps the local days the same regardless of how hour + minutes change
    setUTCHours(hours, minutes, { preserveLocalDaysOfWeek = false, referenceDate = this.earliestDate, } = {}) {
        //  10:00 utc is 3:00 pdt and 2:00 pst
        // pdt is 1 hour ahead
        // now is -8, before was -7.
        // -7 - (-8) = 1
        // -7 is 1 hour ahead
        // therefore 1 on pdt is 0 on pst
        const refDate = new Date(referenceDate);
        let offsetDiff = (this.earliestDate.getTimezoneOffset() - refDate.getTimezoneOffset()) / 60;
        hours = hours.map((h) => h + offsetDiff);
        if (__classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f")) {
            this.earliestDate.setUTCHours(hours[0], minutes && minutes[0]);
            this.parsedCron = (0, parse_1.parse)(__classPrivateFieldGet(this, _EventCronParser_cron, "f"), this.earliestDate, this.latestDate || undefined, __classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f"));
            return;
        }
        const cron = this.parsedCron;
        const localDays = (0, local_1.getLocalDays)(cron);
        // if (preserveLocalDaysOfWeek) {
        //     const oldDate = new Date()
        //     oldDate.setUTCHours(this.parsedCron.hours[0] as number, this.parsedCron.minutes[0] as number,0,0)
        //     const newDate = new Date()
        //     newDate.setUTCHours(hours[0], minutes ? minutes[0] : this.parsedCron.minutes[0] as number,0,0)
        //     // check if same utcday but different localday
        //     const oldLocalDay = nextUTCDay(oldDate, 1).getDay()
        //     const newLocalDay = nextUTCDay(newDate, 1).getDay()
        //     if (oldLocalDay !== newLocalDay) {
        //         // change hours then set days of week again
        //         this.setDaysOfWeek(localDays, 'local')
        //     }
        // }
        const cronArray = __classPrivateFieldGet(this, _EventCronParser_cron, "f").split(' ');
        cronArray[1] = hours.join(',');
        if (minutes)
            cronArray[0] = minutes.join(',');
        __classPrivateFieldSet(this, _EventCronParser_cron, cronArray.join(' '), "f");
        cron.hours = hours;
        if (minutes)
            cron.minutes = minutes;
        if (preserveLocalDaysOfWeek)
            this.setDaysOfWeek(localDays, 'local');
    }
    setDaysOfWeek(daysOfWeek, timezone) {
        timezone = timezone !== null && timezone !== void 0 ? timezone : this.tz;
        if (__classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f")) {
            this.setCron(constants_1.EMPTY_CRON);
        }
        const parsedCron = this.parsedCron;
        // 1. convert daysOfWeek to UTC
        // 2. update cron
        const updated = timezone === 'utc' ? daysOfWeek : (0, local_1.convertLocalDaysOfWeekToUTC)(daysOfWeek, parsedCron);
        const cronArray = __classPrivateFieldGet(this, _EventCronParser_cron, "f").split(' ');
        cronArray[4] = updated.join(',');
        __classPrivateFieldSet(this, _EventCronParser_cron, cronArray.join(' '), "f");
        parsedCron.daysOfWeek = updated;
        return updated;
    }
    getCron() {
        return __classPrivateFieldGet(this, _EventCronParser_cron, "f");
    }
    isRateExpression() {
        return __classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f");
    }
    setDuration(duration) {
        this.parsedCron.duration = duration;
        if (__classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f")) {
            const arr = __classPrivateFieldGet(this, _EventCronParser_cron, "f").substring(5, __classPrivateFieldGet(this, _EventCronParser_cron, "f").length - 1).split(',');
            arr[1] = duration.toString();
            __classPrivateFieldSet(this, _EventCronParser_cron, 'rate(' + arr.join(',') + ')', "f");
        }
        else {
            const split = __classPrivateFieldGet(this, _EventCronParser_cron, "f").split(' ');
            split[6] = duration.toString();
            __classPrivateFieldSet(this, _EventCronParser_cron, split.join(' '), "f");
        }
        return __classPrivateFieldGet(this, _EventCronParser_cron, "f");
    }
    validate() {
        if (isNaN(this.parsedCron.duration))
            throw new Error('invalid duration');
        if (__classPrivateFieldGet(this, _EventCronParser_isRateExpression, "f")) {
            if (this.parsedCron.value <= 0)
                throw new Error('invalid value');
            return;
            // rest is validated in parse
        }
        const parsedCron = this.parsedCron;
        (0, parse_1.validateParsedRule)(parsedCron.minutes);
        (0, parse_1.validateParsedRule)(parsedCron.hours);
        (0, parse_1.validateParsedRule)(parsedCron.daysOfMonth);
        (0, parse_1.validateParsedRule)(parsedCron.months);
        (0, parse_1.validateParsedRule)(parsedCron.daysOfWeek);
        (0, parse_1.validateParsedRule)(parsedCron.years);
    }
}
_EventCronParser_cron = new WeakMap(), _EventCronParser_prevDate = new WeakMap(), _EventCronParser_isRateExpression = new WeakMap();
exports.default = EventCronParser;
//# sourceMappingURL=index.js.map